/**
 * Utility service for reference data
 */
import axios from 'axios';
import { API_BASE_URL } from '../constants/api';
import apiClient from './apiClient';

export const utilityService = {
  /**
   * Get all countries
   * @returns {Promise} List of countries
   */
  getCountries: async () => {
    return apiClient.get('/utility/countries');
  },

  /**
   * Get all nationalities
   * @returns {Promise} List of nationalities
   */
  getNationalities: async () => {
    return apiClient.get('/utility/nationalities');
  },

  /**
   * Get all security questions
   * @returns {Promise} List of security questions
   */
  getSecurityQuestions: async () => {
    return apiClient.get('/utility/security-questions');
  },

  /**
   * Get all timezones
   * @returns {Promise} List of timezones
   */
  getTimezones: async () => {
    return apiClient.get('/utility/timezones');
  },

  /**
   * Get all world timezones
   * @returns {Promise} List of world timezones
   */
  getWorldTimezones: async () => {
    return apiClient.get('/utility/world-timezones');
  },

  /**
   * Get country by phone code
   * @param {string} phoneCode - Phone code (e.g., "+1")
   * @returns {Promise} Country details
   */
  getCountryByPhoneCode: async (phoneCode) => {
    return apiClient.get(`/utility/country/phone-code/${phoneCode}`);
  },

  /**
   * Health check
   * @returns {Promise} Health status
   */
  healthCheck: async () => {
    return apiClient.get('/utility/health');
  },

  /**
   * Submit help center form
   * @param {Object} parameter - Help form payload
   * @returns {Promise} API response
   */
  helpCenterApi: async (parameter) => {
    console.log('helpCenterApi', parameter);

    try {
      const response = await axios.post(`${API_BASE_URL}/search/adminHelp`, parameter, {
        headers: {
          accept: '*/*',
          'Content-Type': 'application/json'
        }
      });

      console.log('helpCenterApi --------->', response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export const helpCenterApi = utilityService.helpCenterApi;

export default utilityService;
